const DATE_FORMATTER = new Intl.DateTimeFormat('en-NL', {
  weekday: 'short',
  day: '2-digit',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'Europe/Amsterdam',
});

export function formatLessonDate(value: string): string {
  return DATE_FORMATTER.format(new Date(value));
}

export function weekdayLabel(weekday: number): string {
  const labels = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return labels[weekday] ?? String(weekday);
}
